(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-share"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  // Garante que o listener de ESC seja adicionado apenas uma vez,
  // mesmo que initShareCart seja chamado múltiplas vezes após refresh.
  let _escBound = false;

  // ─── Auxiliares ──────────────────────────────────────────────────────────────

  async function _fetchCart() {
    const r = await fetch('/cart.js', { cache: 'no-store' });
    return r.json();
  }

  function _buildShareUrl(cart) {
    if (!cart.items.length) return '';
    const items = cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');
    let url = `${location.origin}/cart/${items}`;
    if (cart.cart_level_discount_applications?.length) {
      const d = cart.cart_level_discount_applications[0].title;
      if (d) url += `?discount=${encodeURIComponent(d)}`;
    }
    return url;
  }

  function _openModal() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const modal = document.querySelector('[data-cart-share-modal]');
    if (!overlay || !modal) return;
    overlay.classList.remove('hidden');
    overlay.classList.add('flex');
    overlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      modal.classList.remove('scale-95', 'opacity-0');
      modal.classList.add('scale-100', 'opacity-100');
    });
  }

  function _closeModal() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const modal = document.querySelector('[data-cart-share-modal]');
    const qrBox = document.querySelector('[data-cart-share-qr-box]');
    if (!overlay || !modal) return;
    modal.classList.add('scale-95', 'opacity-0');
    modal.classList.remove('scale-100', 'opacity-100');
    setTimeout(() => {
      overlay.classList.remove('flex');
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
      if (qrBox) qrBox.classList.add('hidden');
    }, 200);
  }

  function _showToast() {
    const toast = document.querySelector('[data-cart-share-toast]');
    if (!toast) return;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) scale(1)';
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) scale(0.95)';
    }, 1500);
  }

  // ─── Ligação de eventos ───────────────────────────────────────────────────────
  // Chamada após cada refresh do drawer para religar eventos aos novos elementos.

  function _bind() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const copyBtn = document.querySelector('[data-cart-share-copy]');
    const qrBtn   = document.querySelector('[data-cart-share-qr]');
    const qrImg   = document.querySelector('[data-cart-share-qr-img]');
    const qrBox   = document.querySelector('[data-cart-share-qr-box]');

    // Fechar ao clicar fora do modal
    overlay?.addEventListener('click', (e) => {
      if (e.target === overlay) _closeModal();
    });

    // Fechar via ESC — adicionado uma única vez no document
    if (!_escBound) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') _closeModal();
      });
      _escBound = true;
    }

    // Copiar link
    copyBtn?.addEventListener('click', async () => {
      const cart = await _fetchCart();
      const url = _buildShareUrl(cart);
      if (!url) return;
      await navigator.clipboard.writeText(url);
      _showToast();
    });

    // QR Code
    qrBtn?.addEventListener('click', async () => {
      const cart = await _fetchCart();
      const url = _buildShareUrl(cart);
      if (!url || !qrImg || !qrBox) return;
      qrImg.src = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(url)}`;
      qrBox.classList.remove('hidden');
    });
  }

  // Fecha o modal quando o drawer fechar
  document.addEventListener('cartDrawer:closed', _closeModal);

  // ─── Gatilho (delegação no document) ─────────────────────────────────────────
  // Usa delegação para funcionar mesmo após o trigger ser re-renderizado
  // pelo refresh do drawer.

  document.addEventListener('click', async (e) => {
    if (!e.target.closest('[data-cart-share-open]')) return;
    const cart = await _fetchCart();
    const url = _buildShareUrl(cart);
    const waBtn = document.querySelector('[data-cart-share-whatsapp]');
    if (waBtn && url) {
      waBtn.href = `https://wa.me/?text=${encodeURIComponent(`Olha meu carrinho: ${url}`)}`;
    }
    _openModal();
  });

  // ─── Inicialização ─────────────────────────────────────────────────────────────

  window.initShareCart = () => {
    // Após refresh do drawer, re-liga os eventos aos novos elementos renderizados.
    _bind();
    console.log('[CartShare] Initialized');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initShareCart);
  } else {
    window.initShareCart();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateTooltipPosition = (swatch) => {
      swatch.style.setProperty('--pdp-tooltip-offset-x', '0px');

      const swatchRect = swatch.getBoundingClientRect();
      const tooltipStyle = getComputedStyle(swatch, '::after');
      let tooltipWidth = Number.parseFloat(tooltipStyle.width) || 0;

      if (tooltipStyle.boxSizing === 'content-box') {
        tooltipWidth += Number.parseFloat(tooltipStyle.paddingLeft) || 0;
        tooltipWidth += Number.parseFloat(tooltipStyle.paddingRight) || 0;
      }

      const viewportMargin = 8;
      const tooltipCenter = swatchRect.left + (swatchRect.width / 2);
      const tooltipLeft = tooltipCenter - (tooltipWidth / 2);
      const tooltipRight = tooltipCenter + (tooltipWidth / 2);
      let offsetX = 0;

      if (tooltipLeft < viewportMargin) {
        offsetX = viewportMargin - tooltipLeft;
      } else if (tooltipRight > window.innerWidth - viewportMargin) {
        offsetX = (window.innerWidth - viewportMargin) - tooltipRight;
      }

      swatch.style.setProperty('--pdp-tooltip-offset-x', `${offsetX}px`);
    };

    const initPdpColorTooltips = () => {
      document.querySelectorAll('.productCard__swatch-pdp[data-color-name]').forEach((swatch) => {
        if (swatch.dataset.tooltipReady === 'true') return;

        swatch.addEventListener('pointerenter', () => updateTooltipPosition(swatch));
        swatch.addEventListener('focus', () => updateTooltipPosition(swatch));
        swatch.dataset.tooltipReady = 'true';
      });
    };

    const initPdpColorExpanders = () => {
      document.querySelectorAll('[data-pdp-color-more-toggle]').forEach((toggle) => {
        if (toggle.dataset.ready === 'true') return;

        const remainingColors = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!remainingColors) return;

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
          remainingColors.hidden = isExpanded;
          toggle.textContent = isExpanded ? toggle.dataset.collapsedLabel : 'Ocultar cores';
        });

        toggle.dataset.collapsedLabel = toggle.textContent.trim();
        toggle.dataset.ready = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initPdpColorExpanders();
        initPdpColorTooltips();
      }, { once: true });
    } else {
      initPdpColorExpanders();
      initPdpColorTooltips();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    (() => {
    const backToTopButton = document.querySelector('[data-back-to-top-button]');
    if (!backToTopButton || backToTopButton.dataset.initialized === 'true') return;

    backToTopButton.dataset.initialized = 'true';
    backToTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        backToTopButton.classList.add('is-visible');
      } else {
        backToTopButton.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  })();
  } catch(e) { console.error(e); }
})();

})();
